import styled from 'styled-components';
import { Theme } from '@cubeyou-team/hx-theme';

export const StyledSavedQuery = styled.div<{
  theme: Theme;
  isClickable: boolean;
}>`
  align-items: center;
  position: relative;
  padding-left: ${props => props.theme.spacing.medium};
  padding-right: ${props => props.theme.spacing.medium};
  padding-top: ${props => props.theme.spacing.small};
  padding-bottom: ${props => props.theme.spacing.small};
  border-radius: ${props => props.theme.border_radius.standard};
  background-color: transparent;
  cursor: ${props => (props.isClickable ? 'pointer' : 'auto')};

  &:focus {
    outline: none;
  }
  &:hover {
    background-color: ${props => props.theme.colors.light};
  }
`;

export const StyledText = styled.div`
  span {
    line-height: 2px;
  }
`;
